import Rest from '../Rest'
import store from '@/store/store'

export default class TwoFactorService extends Rest {

  /**
   * @type {String}
   */
  static resource = '/api/v1/a2fa';

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  getQRCodeURL(payload: any = {}) {
    return this.post(`/qrcode_2fa_url`, payload).then((data) => {
      return data
    })
  }

  verify2fa(form: any = {}) {
    return this.post(`/verify`, form).then(data => {
      return data
    })
  }
}
